module.exports = __webpack_public_path__ + "img/img2.3129a1cf.png";